import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Mail, Globe } from "lucide-react";

export default function Contatti() {
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-5 py-8 space-y-6 text-slate-700">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A] transition-colors mb-2" data-testid="back-btn">
        <ArrowLeft className="w-4 h-4" /> Indietro
      </button>
      <h1 className="font-heading text-3xl font-bold text-[#0F172A]">Contatti</h1>
      <p className="text-sm text-slate-500">
        Per qualsiasi informazione, richiesta o segnalazione relativa all'applicazione venditoreElite.
      </p>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 bg-slate-50 rounded-lg flex items-center justify-center flex-shrink-0">
            <Mail className="w-4 h-4 text-slate-500" />
          </div>
          <div>
            <div className="text-xs text-slate-400 uppercase tracking-wider mb-0.5">Email</div>
            <a
              href="mailto:agenteelite@libero.it"
              className="text-sm text-blue-600 hover:underline font-medium"
              data-testid="contact-email"
            >
              agenteelite@libero.it
            </a>
          </div>
        </div>
      </div>

      <p className="text-xs text-slate-400 leading-relaxed">
        Risponderemo entro 2 giorni lavorativi. Per informazioni sul trattamento dei dati consulta la{" "}
        <a href="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</a>.
      </p>
    </div>
  );
}
